<template>
  <div class="video-item" :class="[videoLink != '' ? 'embedded' : videoFileUrl != '' ? 'has-file' : '']">
    <div class="video-item-wrapper">
      <iframe ref="videoIframe" :src="iframeSrc" allow="autoplay" v-if="videoLink != ''"></iframe>
      <video ref="videoElement" controls v-else-if="videoFileUrl != ''">
		<source :src="vidFileSrc" type="video/mp4"></source>
	  </video>
      <img ref="videoPoster" v-if="props.posterImageUrl" :src="props.posterImageUrl" />
    </div>
    <div ref="playButton" class="video-overlay" @click="play()">
      <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 60 60">
      <path d="m45.563 29.174-22-15A1 1 0 0 0 22 15v30a.999.999 0 0 0 1.563.826l22-15a1 1 0 0 0 0-1.652zM24 43.107V16.893L43.225 30 24 43.107z" />
      <path d="M30 0C13.458 0 0 13.458 0 30s13.458 30 30 30 30-13.458 30-30S46.542 0 30 0zm0 58C14.561 58 2 45.439 2 30S14.561 2 30 2s28 12.561 28 28-12.561 28-28 28z" />
			</svg>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, ref } from 'vue';
  import getVideoId from 'get-video-id';

  const props = defineProps({
    posterImageUrl: String,
    videoFileUrl: String,
    videoLink: String,
  });

  const videoIframe = ref<HTMLIFrameElement>(null!);
  const videoElement = ref<HTMLVideoElement>(null!);
  const playButton = ref<HTMLDivElement>(null!);
  const videoPoster = ref<HTMLImageElement>(null!);
  const iframeSrc = ref<string>();
  const vidFileSrc = ref<string>();

  let vidPlaying = Boolean(false);

  function play() {
    vidPlaying = true;
	videoPoster.value.style.display = 'none';
    playButton.value.style.display = 'none';

    if (videoIframe.value && props.videoLink) {
      iframeSrc.value = iframeSrc.value + '?autoplay=1';
    } else if (videoElement.value && props.videoFileUrl) {
      videoElement.value.play();
    }
  }

  onMounted(() => {
    if (videoIframe.value && props.videoLink) {
      const { id, service } = getVideoId(props.videoLink);

      if (service == 'youtube') {
        iframeSrc.value = `https://www.youtube.com/embed/${id}`;
      }
      if (service == 'vimeo') {
        iframeSrc.value = `https://player.vimeo.com/video/${id}`;
      }
    } else if (videoElement.value && props.videoFileUrl) {
      	vidFileSrc.value = props.videoFileUrl;
    }
  });
</script>
